var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "p-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "auto" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "合同照片：" } },
                    [
                      _c("upload", {
                        attrs: { emitUrl: false, limit: 99 },
                        model: {
                          value: _vm.form.contract_url,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "contract_url", $$v)
                          },
                          expression: "form.contract_url",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "身份信息：" } },
                    [
                      _c("upload", {
                        attrs: { emitUrl: false, limit: 99 },
                        model: {
                          value: _vm.form.identity_url,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "identity_url", $$v)
                          },
                          expression: "form.identity_url",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "其他信息：" } },
                    [
                      _c("upload", {
                        attrs: { emitUrl: false, limit: 99 },
                        model: {
                          value: _vm.form.extra_url,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "extra_url", $$v)
                          },
                          expression: "form.extra_url",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.level == 1 && _vm.checkRoles(["terminal"])
                    ? [
                        _c(
                          "el-form-item",
                          { ref: "form", attrs: { label: "合同时间类型：" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.form.date_type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "date_type", $$v)
                                  },
                                  expression: "form.date_type",
                                },
                              },
                              [
                                _c(
                                  "el-radio-button",
                                  { attrs: { label: "2" } },
                                  [_vm._v("月付")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-radio-button",
                                  { attrs: { label: "1" } },
                                  [_vm._v("年付")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-radio-button",
                                  { attrs: { label: "0" } },
                                  [_vm._v("永久")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.form.date_type == 2
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "已缴押金：" } },
                              [
                                _c(
                                  "el-input",
                                  {
                                    model: {
                                      value: _vm.form.taked_deposite,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "taked_deposite",
                                          $$v
                                        )
                                      },
                                      expression: "form.taked_deposite",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("元"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.form.date_type == 2 || _vm.form.date_type == 1
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "已付月数：" } },
                              [
                                _c(
                                  "el-input",
                                  {
                                    model: {
                                      value: _vm.form.taked_months,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "taked_months", $$v)
                                      },
                                      expression: "form.taked_months",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("月"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.form.date_type == 1 || _vm.form.date_type == 2
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "合同开始时间：" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "date",
                                    placeholder: "开始时间",
                                    "value-format": "timestamp",
                                  },
                                  model: {
                                    value: _vm.form.begin,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "begin", $$v)
                                    },
                                    expression: "form.begin",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.onSubmit()
                            },
                          },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }